import React, { useState } from 'react';

import { createTheme, ThemeProvider } from '@mui/material/styles';

import websitelogo from '../../../../assets/logos/websitelogo.svg';

import CallIcon from '@mui/icons-material/Call';

import ChatIcon from '@mui/icons-material/Chat';

import ContactSupportIcon from '@mui/icons-material/ContactSupport';

import { feedback } from '../../../services/api/apiManager';

import StarIcon from '@mui/icons-material/Star';

import {
	Alert,
	Box,
	CssBaseline,
	Grid,
	Rating,
	Snackbar,
	TextField,
	Typography,
} from '@mui/material';

import { Link } from 'react-router-dom';

import Paper from '@mui/material/Paper';

import Button from '@mui/material/Button';

function Feedback() {
	const defaultTheme = createTheme();
	const [value, setValue] = useState('');
	const [feedbackText, setFeedbackText] = useState('');

	const [openSnackbar, setOpenSnackbar] = useState(false);
	const [error401Snackbar, setError401Snackbar] = useState(false);

	const handleSubmit = async () => {
		try {
			debugger;

			const response = await feedback({
				Uid: 2147483647,
				Rating: value,
				Feedback: feedbackText,
			});
			// Optionally, you can add code here to handle the response if needed.
			setFeedbackText('');
			// Optionally, you can add code here to handle success state or feedback to the user.

			if (response?.status === 200) {
				setOpenSnackbar(true);
			} else if (response?.status === 401) {
				setError401Snackbar(true);
			} else {
				setError401Snackbar(true);
			}
		} catch (error) {
			// Optionally, you can add code here to handle errors if needed.
			setError401Snackbar(true);
		}
	};
	const handleSnackbarClose = () => {
		setOpenSnackbar(false);
		setError401Snackbar(false);
	};

	return (
		<ThemeProvider theme={defaultTheme}>
			<Grid
				container
				component="main"
				sx={{
					height: '100vh',
					backgroundImage: `url(${require('../../../../assets/images/background.png')})`,
					backgroundRepeat: 'no-repeat',
					backgroundSize: 'cover',
					backgroundPosition: 'center',
					padding: '30px 30px',
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					'@media (max-width: 600px)': {
						// Styles for xs and sm screens
						padding: '10px',
					},
				}}
			>
				<CssBaseline />
				<Grid container item justifyContent="center">
					<Grid
						item
						xs={false}
						sm={6}
						md={6}
						lg={4.5}
						xl={4}
						sx={{
							backgroundImage: `url(${require('../../../../assets/images/singupbacground.png')})`,
							backgroundRepeat: 'no-repeat',
							backgroundPosition: 'center',
							backgroundSize: 'cover',
							display: 'flex',
							flexDirection: 'column',
							borderRadius: '15px 0px 0px 15px',
							justifyContent: 'space-between',
							// background: '#197CCC',
							display: { sm: 'none', xs: 'none', md: 'flex', xl: 'flex' },
						}}
					>
						<Grid
							item
							sx={{
								display: 'flex',
								flex: '1',
								flexDirection: 'column',
								alignItems: 'center',
								justifyContent: 'center',
								textAlign: 'center',
							}}
						>
							<Box>
								<Typography
									gutterBottom
									variant="h5"
									sx={{
										color: 'white',
										fontSize: '25px',
										fontWeight: '500',
										fontFamily: 'Poppins',
									}}
								>
									VALUABLE FEEDBACK !
								</Typography>
								<Typography
									variant="h5"
									sx={{
										color: 'white',
										fontSize: '19px',
										fontFamily: 'Poppins',
										textAlign: 'center',
										fontWeight: '300',
									}}
								>
									We work hard to provide the best
									<br /> services and ensure customer
									<br /> happiness
								</Typography>
							</Box>
						</Grid>
						<Grid
							item
							sx={{
								display: 'flex',
								justifyContent: 'space-evenly',
								borderTop: '0.5px solid rgba(255, 255, 255, 0.40)',
								padding: '15px 50px',
							}}
						>
							<Grid
								container
								alignItems="center"
								justifyContent="center"
								spacing={1} // Adjust the spacing as needed
							>
								<Grid item>
									<ContactSupportIcon sx={{ color: 'white' }} />
								</Grid>
								<Grid item>
									<Link to={'/aboutUs'}>
										<Typography
											variant="body1"
											sx={{
												color: 'white',
												fontWeight: '700',
												textDecoration: 'underline',
											}}
										>
											About Us
										</Typography>
									</Link>
								</Grid>
							</Grid>

							<Grid
								container
								alignItems="center"
								justifyContent="center"
								spacing={1} // Adjust the spacing as needed
							>
								<Grid item>
									<CallIcon sx={{ color: 'white' }} />
								</Grid>
								<Grid item>
									<Link to={'/contactUs'}>
										<Typography
											variant="body1"
											sx={{
												color: 'white',
												fontWeight: '700',
												textDecoration: 'underline',
											}}
										>
											Contact Us
										</Typography>
									</Link>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
					<Grid
						component={Paper}
						square
						item
						xs={10}
						sm={9}
						md={6}
						lg={4.5}
						xl={4}
						sx={{
							backgroundImage: `url(${require('../../../../assets/images/formbackground.png')})`,
							backgroundRepeat: 'no-repeat',
							backgroundSize: 'cover',
							backgroundPosition: 'center',
							borderRadius: '0px 15px 15px 0px',
							'@media (max-width: 600px)': {
								// Styles for xs and sm screens
								borderRadius: '15px',
							},
							'@media (max-width: 900px)': {
								// Styles for xs and sm screens
								borderRadius: '15px',
								justifyContent: 'center',
							},
						}}
					>
						<Box
							sx={{
								padding: '15px 30px',
								display: 'flex',
								flexDirection: 'column',
								'@media (max-width: 600px)': {
									// Styles for xs and sm screens
									padding: '10px',
								},
							}}
						>
							<img
								src={websitelogo}
								alt="Your Alt Text"
								style={{
									maxWidth: '200px',
									height: 'auto',
									objectFit: 'contain',
								}}
							/>
							<Typography
								component="h1"
								variant="h5"
								sx={{
									alignSelf: 'start',
									fontSize: '25px',
									fontWeight: '600',
									mt: '10px',
								}}
							>
								Feedback
							</Typography>
							<Box
								component="form"
								noValidate
								sx={{
									mt: 1,
								}}
							>
								<Grid
									container
									spacing={2}
									justifyContent="center"
									alignItems="center"
								>
									<Grid item textAlign="center" sx={{ margin: '20px' }}>
										<Typography
											variant="body1"
											sx={{
												color: '#6F6A6A',
												textAlign: 'center',
												fontFamily: 'Poppins',
												fontSize: '23px',
												fontStyle: 'normal',
												fontWeight: '400',
												lineHeight: 'normal',
											}}
										>
											How much are you satisfied ?
										</Typography>
										<Rating
											name="simple-controlled"
											value={value}
											icon={
												<StarIcon style={{ color: '#FFDC79', margin: '8px' }} />
											}
											emptyIcon={
												<StarIcon style={{ border: 'none', margin: '8px' }} />
											}
											onChange={(event, newValue) => {
												setValue(newValue);
											}}
											sx={{
												borderRadius: '9px 9px 9px 0px',
												background: ' #4BA5EF',
												padding: '5px 25px',
												marginTop: '5px',
												marginBottom: '5px',
												'& .MuiSvgIcon-root': {
													fontSize: '30px',
												},
											}}
										/>
									</Grid>
								</Grid>
								<Typography
									variant="body2"
									sx={{ color: '#7E7D7D', fontSize: '15px' }}
								>
									Any Suggestions?
								</Typography>
								<TextField
									multiline
									fullWidth
									value={feedbackText}
									onChange={(e) => setFeedbackText(e.target.value)}
									rows={5}
									variant="outlined"
									sx={{
										borderRadius: '6px',
										border: '1.5px solid #DDE6F1',
										marginBottom: '60px',
										boxShadow: '0px 1px 4px 0px rgba(0, 0, 0, 0.25) inset',
									}}
								/>
								<Button
									variant="contained"
									onClick={() => handleSubmit()}
									fullWidth
									sx={{
										background: ' #e87511',
										borderRadius: '6px',
										height: '50px',
										marginTop: '100px',
										fontFamily: 'Poppins',
										fontSize: '25px',
										fontWeight: '400',
										marginTop: '20px',
										'&:hover': {
											background: '#e87511',
										},
									}}
								>
									SUBMIT
								</Button>
								<Snackbar
									open={openSnackbar}
									autoHideDuration={3000} // Adjust the duration as needed
									onClose={handleSnackbarClose}
									anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
								>
									<Alert onClose={handleSnackbarClose} severity="success">
										Feedback Recorded successfully.
									</Alert>
								</Snackbar>
								{/* error 401 snackbar */}
								<Snackbar
									open={error401Snackbar}
									autoHideDuration={6000}
									onClose={handleSnackbarClose}
									anchorOrigin={{ vertical: 'center', horizontal: 'center' }}
								>
									<Alert
										onClose={handleSnackbarClose}
										severity="error"
										sx={{
											width: '100%',
											background: 'red',
											color: 'white',
											fontFamily: 'Poppins',
											'& .MuiAlert-icon': {
												color: 'white', // Change icon color to white
											},
										}}
									>
										Error 401
									</Alert>
								</Snackbar>
							</Box>
						</Box>
					</Grid>
				</Grid>
			</Grid>
		</ThemeProvider>
	);
}

export default Feedback;
